export const declineRenewalTitle = 'Are you sure you want to decline renewal for the selected order?';
export const reasonDecline = 'Reason for decline';
